"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotebookPreview = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = require("styled-jsx/style");

var _style2 = _interopRequireDefault(_style);

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _immutable = require("immutable");

var Immutable = _interopRequireWildcard(_immutable);

var _displayArea = require("@nteract/display-area");

var _transforms = require("@nteract/transforms");

var _commutable = require("@nteract/commutable");

var _presentationalComponents = require("@nteract/presentational-components");

var _papermill = require("./papermill");

var _markdown = require("@nteract/markdown");

var _markdown2 = _interopRequireDefault(_markdown);

var _mathjax = require("@nteract/mathjax");

var _mathjax2 = _interopRequireDefault(_mathjax);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NotebookPreview = exports.NotebookPreview = function (_React$PureComponent) {
  _inherits(NotebookPreview, _React$PureComponent);

  function NotebookPreview(props) {
    _classCallCheck(this, NotebookPreview);

    var _this = _possibleConstructorReturn(this, (NotebookPreview.__proto__ || Object.getPrototypeOf(NotebookPreview)).call(this, props));

    _this.state = {
      notebook: (0, _commutable.fromJS)(props.notebook)
    };
    return _this;
  }

  _createClass(NotebookPreview, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.notebook !== this.props.notebook) {
        this.setState({ notebook: (0, _commutable.fromJS)(nextProps.notebook) });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // TODO: Rely on setState to convert notebook from plain JS to commutable format

      var notebook = this.state.notebook;

      // Propagated from the hide_(all)_input nbextension
      var allSourceHidden = notebook.getIn(["metadata", "hide_input"], false);

      var language = notebook.getIn(["metadata", "language_info", "codemirror_mode", "name"], notebook.getIn(["metadata", "language_info", "codemirror_mode"], notebook.getIn(["metadata", "language_info", "name"], "text")));

      var cellOrder = notebook.get("cellOrder");
      var cellMap = notebook.get("cellMap");

      return React.createElement(
        _mathjax2.default.Context,
        null,
        React.createElement(
          "div",
          { className: "notebook-preview" },
          React.createElement(
            _presentationalComponents.Cells,
            null,
            cellOrder.map(function (cellID) {
              var cell = cellMap.get(cellID);
              var cellType = cell.get("cell_type");
              var source = cell.get("source");

              switch (cellType) {
                case "code":
                  var sourceHidden = allSourceHidden || cell.getIn(["metadata", "inputHidden"]) || cell.getIn(["metadata", "hide_input"]);

                  var outputHidden = cell.get("outputs").size === 0 || cell.getIn(["metadata", "outputHidden"]);

                  var papermillStatus = cell.getIn(["metadata", "papermill", "status"], null);

                  return React.createElement(
                    _presentationalComponents.Cell,
                    { key: cellID },
                    React.createElement(_papermill.PapermillView, { status: papermillStatus }),
                    React.createElement(
                      _presentationalComponents.Input,
                      { hidden: sourceHidden },
                      React.createElement(_presentationalComponents.Prompt, {
                        counter: cell.get("execution_count"),
                        running: papermillStatus === "running"
                      }),
                      React.createElement(
                        _presentationalComponents.Source,
                        { language: language, theme: _this2.props.theme },
                        source
                      )
                    ),
                    React.createElement(
                      _presentationalComponents.Outputs,
                      {
                        hidden: outputHidden,
                        expanded: cell.getIn(["metadata", "outputExpanded"], true)
                      },
                      React.createElement(_displayArea.Display, {
                        outputs: cell.get("outputs").toJS(),
                        transforms: _this2.props.transforms,
                        displayOrder: _this2.props.displayOrder
                      })
                    )
                  );
                case "markdown":
                  return React.createElement(
                    _presentationalComponents.Cell,
                    { key: cellID },
                    React.createElement(
                      "div",
                      {
                        className: "jsx-2513275823" + " " + "content-margin"
                      },
                      React.createElement(_markdown2.default, { source: source })
                    ),
                    React.createElement(_style2.default, {
                      styleId: "2513275823",
                      css: ".content-margin.jsx-2513275823{padding-left:calc(var(--prompt-width,50px) + 10px);padding-top:10px;padding-bottom:10px;padding-right:10px;}"
                    })
                  );
                case "raw":
                  return React.createElement(
                    _presentationalComponents.Cell,
                    { key: cellID },
                    React.createElement(
                      "pre",
                      {
                        className: "jsx-1171811947" + " " + "raw-cell"
                      },
                      source,
                      React.createElement(_style2.default, {
                        styleId: "1171811947",
                        css: "raw-cell.jsx-1171811947{background:repeating-linear-gradient( -45deg, transparent, transparent 10px, #efefef 10px, #f1f1f1 20px );}"
                      })
                    )
                  );

                default:
                  return React.createElement(
                    _presentationalComponents.Cell,
                    { key: cellID },
                    React.createElement(
                      _presentationalComponents.Outputs,
                      null,
                      React.createElement(
                        "pre",
                        null,
                        "Cell Type \"" + cellType + "\" is not implemented"
                      )
                    )
                  );
              }
            })
          ),
          React.createElement(
            "style",
            null,
            ":root {\n          " + _presentationalComponents.themes[this.props.theme] + "\n            --theme-cell-shadow-hover: none;\n            --theme-cell-shadow-focus: none;\n            --theme-cell-prompt-bg-hover: var(--theme-cell-prompt-bg);\n            --theme-cell-prompt-bg-focus: var(--theme-cell-prompt-bg);\n            --theme-cell-prompt-fg-hover: var(--theme-cell-prompt-fg);\n            --theme-cell-prompt-fg-focus: var(--theme-cell-prompt-fg);\n          }\n        "
          )
        )
      );
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return NotebookPreview;
}(React.PureComponent);

NotebookPreview.defaultProps = {
  displayOrder: _transforms.displayOrder,
  transforms: _transforms.transforms,
  notebook: (0, _commutable.appendCellToNotebook)(_commutable.emptyNotebook, (0, _commutable.createCodeCell)().set("source", "# where's the content?")),
  theme: "light"
};
var _default = NotebookPreview;
exports.default = _default;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(NotebookPreview, "NotebookPreview", "src/index.js");
  reactHotLoader.register(_default, "default", "src/index.js");
  leaveModule(module);
})();

;


//////////////////
// WEBPACK FOOTER
// ./~/@nteract/notebook-preview/lib/index.js
// module id = 204
// module chunks = 186292428941015